import { cn } from "@/lib/utils"

export interface PendingBadgeProps {
  className?: string
  text: string
}

export default function PendingBadge({ className, text }: PendingBadgeProps) {
  return (
    <div
      className={cn(
        `
          border-error border font-roboto h-5.5 py-1 px-2
          text-sm text-error inline-flex items-center justify-center
          w-min
        `,
        className,
      )}
    >
      {text}
    </div>
  )
}
